// extracted by mini-css-extract-plugin
module.exports = {"moreIcon":"moreOption_moreIcon__futV4","moreOption":"moreOption_moreOption__FIflz","optionLine":"moreOption_optionLine__GD8AR","text":"moreOption_text__ltdHg"};